import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import BasicInfoSection from './BasicInfoSection'
import AddressSection from './AddressSection'
import AccountSkeleton from 'sharedComponents/Skeleton/AccountSkeleton'
import { useCurrentUserAccount } from 'hooks/Account'
import { useResize } from 'hooks/common'

function AccountContainer() {
  const { isLoading, account, isAdmin } = useCurrentUserAccount()
  const { isMobile } = useResize()
  if (isLoading) {
    return (
      <Box width='100%'>
        <AccountSkeleton />
      </Box>
    )
  }

  return (
    <Grid
      container
      padding={isMobile ? 2 : 3}
    >
      <Grid
        item
        alignItems='center'
        xs={12}
      >
        <Box
          display='flex'
          align-items='center'
          justifyContent='space-between'
          marginBottom={2}
        >
          <Typography
            variant='h4'
            sx={{
              color: '#404040',
              fontFamily: 'Mont-semibold',
            }}
          >
            Account
          </Typography>
        </Box>
      </Grid>
      <BasicInfoSection
        account={account}
        isAdmin={isAdmin}
      />
      <AddressSection
        account={account}
        isAdmin={isAdmin}
      />
    </Grid>
  )
}

export default AccountContainer
